import React from 'react';
import { useIntl } from 'react-intl';

import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';
import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { CreateReportSidebarMode } from '../create-report-sidebar';

export interface ReportCreatedScreenProps {
  onClose: () => void;
  onView: () => void;
  mode?: CreateReportSidebarMode;
}

export const ReportCreatedScreen = ({ onClose, onView, mode = 'report' }: ReportCreatedScreenProps) => {
  const intl = useIntl();
  const isDashboard = mode === 'dashboard';

  return (
    <WizardScreen
      footerMode={FooterMode.CREATED}
      onCancel={onClose}
      onView={onView}
      viewText={
        isDashboard
          ? intl.formatMessage({ id: 'reporting.go_to_dashboard', defaultMessage: 'Go to dashboard' })
          : intl.formatMessage({ id: 'reporting.go_to_report', defaultMessage: 'Go to report' })
      }
    >
      <WizardFinished
        text={
          isDashboard
            ? intl.formatMessage({
                id: 'reporting.dashboard_created_and_saved_as_draft',
                defaultMessage: 'Dashboard created and saved as a draft for review'
              })
            : intl.formatMessage({
                id: 'reporting.report_created_and_saved_as_draft',
                defaultMessage: 'Report created and saved as a draft for review'
              })
        }
      />
    </WizardScreen>
  );
};
